import VehicleTypes from './VehicleTypes'

export default VehicleTypes
